export const TicketType = {
    GeneralCeremonyTicket: "GeneralCeremonyTicket",
    VIPCeremonyTicket: "VIPCeremonyTicket",
};
export function isCeremonyTicket(item) {
    return item?.type === "CeremonyTicket";
}
export function isGeneralCeremonyTicket(item) {
    return item?.type === TicketType.GeneralCeremonyTicket;
}
export function isVIPCeremonyTicket(item) {
    return item?.type === TicketType.VIPCeremonyTicket;
}
//# sourceMappingURL=ceremony-ticket.js.map